
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/house-of-senco",
      function () {
        return require("private-next-pages/house-of-senco.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/house-of-senco"])
      });
    }
  